import {
  Collapse,
  Textarea,
  Column,
  LabeledCheckboxProps,
  LabeledCheckbox,
} from 'components/Blocks';

import { cn } from 'styles';

interface TextToggleProps extends Pick<LabeledCheckboxProps, 'label' | 'labelIcon'> {
  isActive: boolean;
  toggle: () => void;
  text: string;
  setText: (text: string) => void;
  description?: string;
  hasError?: boolean;
}

export function TextToggle({
  isActive,
  toggle,
  text,
  setText,
  description,
  hasError = false,
  ...props
}: TextToggleProps) {
  const handleCheckboxClick = (): void => {
    if (isActive) setText('');

    toggle();
  };

  return (
    <Column gap="4">
      <LabeledCheckbox {...props} checked={isActive} onChange={handleCheckboxClick} />

      <Collapse expanded={isActive}>
        {isActive && (
          <Column gap="2">
            {description && <span className="ml-1 text-sm italic">{description}</span>}

            <Textarea
              className={cn('min-h-16', hasError && 'border-destructive')}
              value={text}
              onChange={({ target }) => setText(target.value)}
            />
          </Column>
        )}
      </Collapse>
    </Column>
  );
}
